import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stripe-elements"
// Mounts Stripe Payment Element for adding/updating payment methods.
// Loads Stripe.js dynamically to work correctly with Turbo navigation.
export default class extends Controller {
  static targets = ["paymentElement", "message", "submitButton", "buttonText", "spinner"]
  static values = {
    publishableKey: String,
    clientSecret: String,
    returnUrl: String
  }

  connect() {
    this.loadStripeJs().then(() => {
      this.initializeElements()
    }).catch((error) => {
      this.showMessage("Failed to load payment form. Please refresh the page.")
      console.error("Stripe.js failed to load:", error)
    })
  }

  loadStripeJs() {
    if (typeof Stripe !== "undefined") {
      return Promise.resolve()
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = "https://js.stripe.com/v3/"
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  initializeElements() {
    this.stripe = Stripe(this.publishableKeyValue)
    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
      appearance: {
        theme: "stripe",
        variables: {
          colorPrimary: "#2563eb",
          borderRadius: "8px"
        }
      }
    })

    this.paymentElement = this.elements.create("payment")
    this.paymentElement.mount(this.paymentElementTarget)
  }

  async submit(event) {
    event.preventDefault()
    this.setLoading(true)

    const { error } = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: this.returnUrlValue
      }
    })

    if (error) {
      this.showMessage(error.message)
      this.setLoading(false)
    }
    // If no error, Stripe redirects to returnUrl
  }

  showMessage(text) {
    this.messageTarget.classList.remove("hidden")
    this.messageTarget.textContent = text
  }

  setLoading(loading) {
    this.submitButtonTarget.disabled = loading
    if (loading) {
      this.buttonTextTarget.classList.add("hidden")
      this.spinnerTarget.classList.remove("hidden")
    } else {
      this.buttonTextTarget.classList.remove("hidden")
      this.spinnerTarget.classList.add("hidden")
    }
  }
}
